export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7553.68e55be1.jpg";